import React, { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { Link as RouterLink } from 'react-router-dom'
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { emailValidateion, requireValidateion } from '../common/Valitation';
import { HttpPostData, JumpPage } from "../common/Util";
import { NewProductParam, ResponseParamBase } from "../common/Types";
import { LoginInfo, LoginStateConext } from "../context/AuthContext";
import { PageTypeParamConverter, RegisterPageType, RegisterPageInfo } from "../context/RegisterPageTypeContext";
import { TitleParamContext } from "../context/TitleContext";
import { OnsiteTextField } from "../customelements/CustomInput";
import base from "../css/base.module.css";
import market from "../css/market.module.scss";
import faq from "../css/faq.module.css";


export interface LoginInputs {
    email: string,
    password: string
}

export type ResponseParam = ResponseParamBase & {
    userdata: LoginInfo,
    AccessToken: string,
    RefreshToken: string,
    Expiration: string,
    jwtToken: string,
}

type RefreshToken = {
    AccessToken: string,
    RefreshToken: string
}

const schema = Yup.object({
    email: emailValidateion,
    password: requireValidateion,
});

export const Login = () => {

    const { handleSubmit, control, formState: { errors } } = useForm<LoginInputs>({
        defaultValues: {
            email: "",
            password: "",
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const ctx = useContext(LoginStateConext);

    const titleContext = useContext(TitleParamContext);

    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [loginError, setLoginError] = useState<string>("");

    const location = useLocation();
    const productParam = location.state as NewProductParam;
    const pagetypeParam: RegisterPageType = PageTypeParamConverter(productParam);

    const onSubmit: SubmitHandler<LoginInputs> = async (data: LoginInputs, event?: BaseSyntheticEvent) => {
        //setLoading(true);
        setLoginError("");
        await HttpPostData<ResponseParam>("authenticate/login", data, setLoading)
            .then(response => {
                if (response.status == 200 && response.data.resultFlg) {
                    ctx.setIsLogin(true);
                    ctx.setLoginInfo({ email: response.data.userdata.email, userName: response.data.userdata.userName });
                    window.localStorage.setItem("clickeracejwttoken", response.data.jwtToken);
                    JumpPage("/MyPage", {}, "マイページ", navigate);
                } else {
                    ctx.setIsLogin(false);
                    ctx.setLoginInfo({ email: "", userName: "" });
                    window.localStorage.removeItem("clickeracejwttoken");
                    setLoginError(response.data.message);
                }
            })
            .catch(e => {
                setLoginError("ログインに失敗しました。");
            })
            .finally(() => {
                //setLoading(false);
            }
            );
    };

    useEffect(() => {
        titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "ログイン", secondSubTitle: "" });
    }, [])

    const ehRegister = function (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        JumpPage<RegisterPageInfo>("/ConsentForm", { registerPageType: pagetypeParam }, "新規登録", navigate);
    }

    return (
        <>
            <section className={market.marketArea}>
                <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                    <div className={faq.faqAreaInner}>
                        <h3>ログイン</h3>
                    </div>
                    <div className={market.marketAreaInner}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>メールアドレス</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                {
                                    <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.email ? true : false}
                                            helperText={errors.email?.message}
                                            margin="normal"
                                            type="email"
                                        />
                                    )}
                                />
                                }
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]} style={{ marginBottom: "10px" }}>
                            <div className={market.marketInputTitle}>
                                <h3>パスワード</h3>
                            </div>

                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="password"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.password ? true : false}
                                            helperText={errors.password?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />

                            </div>
                        </div>
                        <div className={base.centerContents}>
                            <p className={base.errorMessage}>
                                {loginError}
                            </p>
                        </div>
                        <div className={base.centerContents}>
                            <p>
                                <button className={market.marketButton} style={{ marginBottom:"15px" }} disabled={loading} type="submit">ログイン</button>
                            </p>
                        </div>
                        <div className={base.centerContents}>
                            <p>
                                <RouterLink to="/forgetpassword">パスワードを忘れた方はこちら</RouterLink>
                            </p>
                        </div>
                    </div>

                    <div className={faq.faqAreaInner} style={{ marginTop:"50px" }}>
                        <div className={faq.faqCategory}>
                            <h3>サポート会員に新規登録する</h3>
                        </div>
                        <p>製品購入の場合には、サポート会員への登録が必要です。<br />
                        </p>
                    </div>
                    <div className={faq.contactChack}>
                        <div className={base.centerContents}>
                            <p>
                                <button className={market.marketButton} type="button" onClick={(e) => { ehRegister(e) }}>新規登録</button>
                            </p>
                        </div>
                    </div>
                </form>
            </section>
        </>
    );
}